import { createSlice } from '@reduxjs/toolkit'
import { fetchChecksReports } from './thunks/checks';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    filteredCaption: "",
    // Which view the Checks page shows: "reports" (the FS checks) or "inputs"
    // (Checks - CoA, GL). Switched by the header's "Checks - Inputs / Reports"
    // buttons; the Caption dropdown lists the active view's sections.
    view: "reports",
    // Sections of the inputs view ({ title, passed? }), published by that view
    // itself since they are conditional (e.g. "Account codes & names").
    inputSections: []
}

const checksReport = createSlice({
    name: 'CHECKSREPORTSLICE',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setChecksFilteredCaption(state, action) {
          state.filteredCaption = action.payload
      },
        setChecksView(state, action) {
          state.view = action.payload
          state.filteredCaption = ""
      },
        setInputChecksSections(state, action) {
          state.inputSections = action.payload || []
      }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchChecksReports.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchChecksReports.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchChecksReports.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, data, setChecksFilteredCaption, setChecksView, setInputChecksSections } = checksReport.actions

export default checksReport;